import i18n from 'i18next'
import floridayI18n from '@floriday/floriday-ui/i18n'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { en } from './en'
import { nl } from './nl'

const resources = {
  en: {
    translation: en,
  },
  nl: {
    translation: nl,
  },
} as const

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl',
    supportedLngs: ['en', 'nl'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: false,
    },
  })

i18n.on('languageChanged', language => {
  void floridayI18n.changeLanguage(language)
})

void floridayI18n.changeLanguage(i18n.resolvedLanguage ?? i18n.language)

export default i18n
